export function canBeEdited (roleName) {
  return !(roleName === 'administration' || roleName.startsWith('feature/'))
}
